import { render, staticRenderFns } from "./frontendapp.vue?vue&type=template&id=c2aafa08&"
import script from "./frontendapp.vue?vue&type=script&lang=js&"
export * from "./frontendapp.vue?vue&type=script&lang=js&"
import style0 from "./frontendapp.vue?vue&type=style&index=0&id=c2aafa08&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports